import { render, staticRenderFns } from "./DayOfWeekInput.vue?vue&type=template&id=56f10a81&scoped=true&"
import script from "./DayOfWeekInput.vue?vue&type=script&lang=js&"
export * from "./DayOfWeekInput.vue?vue&type=script&lang=js&"
import style0 from "./DayOfWeekInput.vue?vue&type=style&index=0&id=56f10a81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f10a81",
  null
  
)

export default component.exports